module.exports = __webpack_public_path__ + "static/media/desarrolloProductos.92704986.png";